import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { routes } from '../../constants/routes.constants'
import { breakpoints } from '../../constants'
import { WHITE } from '../../styles/colors.style'
import { borderRadius } from '../../styles/reusable.style'
import Button from '../buttons/buttons.component'
import { useCookies } from 'react-cookie'

const StyledDivContainer = styled.div`
	background: #000a50;
	width: 80%;
	padding: 25px 15px;

	position: fixed;
	left: 50%;
	bottom: 20px;
	transform: translate(-50%, -50%);
	margin: 0 auto;
	border-radius: ${borderRadius};
	box-sizing: border-box;
	box-shadow: 3px 3px 6px 1px rgb(0 0 0/ 50%);
	display: flex;
	flex-direction: row;
	color: ${WHITE};
	font-size: 1.2em;
	z-index: 999;

	.link-policy {
		color: white;
		text-decoration: underline;
	}

	div:last-child {
		align-self: center;
		text-align: right;
		flex: 1;
	}

	.button-proceed {
		padding-top: 8px;
		padding-bottom: 8px;
	}

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		width: 90%;
		display: block;
		bottom: -110px;
		.button-proceed {
			margin-top: 10px;
		}
	}
`

const cookieLGPD = () => {
	const [cookies, setCookie] = useCookies(['muviflex_policy_accepted'])
	const [accepted, setAccepted] = useState(false)

	useEffect(() => {
		setAccepted(cookies.muviflex_policy_accepted)
	}, [])

	const onAccepted = () => {
		setAccepted(true)
		setCookie('muviflex_policy_accepted', true, {
			path: '/',
			expires: new Date(Date.now() + 1000000000000)
		})
	}
	return !accepted ? (
		<StyledDivContainer>
			<div>
				Nós utilizamos cookies e outras tecnologias semelhantes para
				melhorar a sua experiência em nossos serviços, personalizar a
				publicidade e recomendar conteúdo de seu interesse. Ao utilizar
				nossos serviços, você concorda com esse monitoramento. Informamos,
				ainda, que atualizamos o nosso{' '}
				<Link className="link-policy" to={routes.POLITICAS}>
					Termo de Uso e Política de Privacidade
				</Link>
				.
			</div>
			<div>
				<Button
					primary={'true'}
					className="button-proceed"
					type="button"
					onClick={onAccepted}>
					Prosseguir
				</Button>
			</div>
		</StyledDivContainer>
	) : null
}

export default cookieLGPD
